import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { jsx as _jsx } from "react/jsx-runtime";
/*global $*/

import React from "react";
import "./ChatLocationMessageItem.scss";
import BDMap from "./BDMap";

var ChatLocationMessageItem =
/** @class */
function (_super) {
  __extends(ChatLocationMessageItem, _super);

  function ChatLocationMessageItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ChatLocationMessageItem.prototype.componentDidMount = function () {
    console.log("location component mounted");
  };

  ChatLocationMessageItem.prototype.componentWillUnmount = function () {
    console.log("location component will unmount");
  };

  ChatLocationMessageItem.prototype.render = function () {
    return _jsx(BDMap, {
      message: this.props.message
    }, void 0);
  };

  return ChatLocationMessageItem;
}(React.Component);

export default ChatLocationMessageItem;